/* eslint-disable max-len */

export default {
  EN: {
    "hbc.settings.title": "Settings",
    "hbc.settings": "Yes, please email me updates, tips, and offers related to this product",
    "hbc.dashboard.title": "Dashboard",
    "hbc.dashboard.left.title": "committed balance",
    "hbc.dashboard.right.title": "date first committed",
    "hbc.dashboard.right.title.two": "date first invested",
    "hbc.dashboard.ok.warning": "Sorry, but your Uphold account does not support Bitcoin. Please contact ",
    "hbc.dashboard.ok.warning.uphold.support": "Uphold Support",
    "hbc.dashboard.pending.warning": "Please complete the setup of your ",
    "hbc.dashboard.pending.warning.uphold": "Uphold account",
    "hbc.dashboard.restricted.warning": "Your Uphold account is subject to limitations, please check ",
    "hbc.dashboard.restricted.warning.your.account": "your account",
    "hbc.dashboard.blocked.warning": "Your Uphold account is restricted, please contact ",
    "hbc.dashboard.status.waitlist": "Status: Waitlist",
    "hbc.dashboard.first.date.jan": "Jan",
    "hbc.dashboard.first.date.feb": "Feb",
    "hbc.dashboard.first.date.mar": "Mar",
    "hbc.dashboard.first.date.apr": "Apr",
    "hbc.dashboard.first.date.may": "May",
    "hbc.dashboard.first.date.jun": "Jun",
    "hbc.dashboard.first.date.jul": "Jul",
    "hbc.dashboard.first.date.aug": "Aug",
    "hbc.dashboard.first.date.sep": "Sep",
    "hbc.dashboard.first.date.oct": "Oct",
    "hbc.dashboard.first.date.nov": "Nov",
    "hbc.dashboard.first.date.dec": "Dec",
    "hbc.dashboard.invest": "invest",
    "hbc.dashboard.insufficient.warning": "You have insufficient funds for your committed deposit. Please check your balance at ",
    "hbc.dashboard.hedged.bitcoin.performance": "hedged bitcoin performance",
    "hbc.dashboard.balance.estimate": "Balance estimate last updated at {currentDate}",
    "hbc.dashboard.balance.estimates.see": "Balance estimates may be different from the actual value upon withdrawal; please see ",
    "hbc.dashboard.for.more.information": " for more information",
    "hbc.dashboard.date": "as of ",
    "hbc.dashboard.account.history": "account history",
    "hbc.dashboard.account.history.date": "Date",
    "hbc.dashboard.account.history.balance": "Balance",
    "hbc.dashboard.account.history.gain.loss": "Gain/Loss",
    "hbc.dashboard.account.history.fee": "Fee",
    "hbc.dashboard.center.title": "CURRENT BALANCE",
    "hbc.dashboard.status.invested": "Status: Invested",
    "hbc.invest.title": "Fiat",
    "hbc.invest.crypto.title": "Crypto",
    "hbc.invest.added": "Added to waitlist:",
    "hbc.invest.modify": "modify",
    "hbc.invest.cancel": "cancel",
    "hbc.invest.select": "Select asset to deposit:",
    "hbc.invest.added.to.waitlist": "Your deposit will be added to the waitlist.",
    "hbc.invest.added.to.waitlist.two": "Deposits and withdrawals are subject to asset conversion costs. Please see ",
    "hbc.invest.added.to.waitlist.two.tos": "Terms of Service",
    "hbc.invest.added.to.waitlist.two.and": " and ",
    "hbc.invest.added.to.waitlist.two.faq": "FAQ",
    "hbc.invest.input": "Enter the amount:",
    "hbc.invest.submit": "submit",
    "hbc.invest.confirm": "Confirm Deposit",
    "hbc.invest.confirm.message": "Add {AmountAndCurrency} to waitlist?",
    "hbc.invest.confirm.ok": "OK",
    "hbc.invest.confirm.no": "NO",
    "hbc.invest.cancel.deposit": "Cancel Deposit",
    "hbc.invest.cancel.deposit.message": "Do you really want to cancel deposit commitment and forfeit your spot on the waitlist?",
    "hbc.invest.cancel.deposit.ok": "OK",
    "hbc.invest.cancel.deposit.no": "NO",
    "hbc.withdraw.amount.committed": " committed",
    "hbc.withdraw.title": "Withdraw",
    "hbc.withdraw.select": "Select asset to withdraw:",
    "hbc.withdraw.percentage": "Enter percentage to withdraw:",
    "hbc.withdraw.your.balance": "Your balance is {AmountAndCurrency} as of {someDefDate}",
    "hbc.withdraw.processed": "Your withdrawal will be processed at {someDefDate}",
    "hbc.withdraw.added.to.waitlist.two": "Withdrawals are subject to asset conversion costs. Please see ",
    "hbc.withdraw.added.to.waitlist.two.tos": "Terms of Service",
    "hbc.withdraw.added.to.waitlist.two.and": " and ",
    "hbc.withdraw.added.to.waitlist.two.faq": "FAQ",
    "hbc.withdraw.added": "Added to waitlist",
    "hbc.withdraw.modify": "modify",
    "hbc.withdraw.cancel": "cancel",
    "hbc.withdraw.cancel.deposit.ok": "OK",
    "hbc.withdraw.cancel.deposit.no": "NO",
    "hbc.withdraw.cancel.deposit": "Withdraw",
    "hbc.withdraw.cancel.deposit.message": "Cancel withdrawal?",
    "hbc.withdraw.cancel.deposit.button": "cancel deposit",
    "hbc.withdraw.withdraw.deposit": "Withdraw",
    "hbc.withdraw.withdraw.deposit.message": "Do you really want to withdraw your asset?",
    "hbc.withdraw.withdraw.deposit.ok": "OK",
    "hbc.withdraw.withdraw.deposit.no": "NO",
    "hbc.withdraw.withdraw.deposit.error.small": "Withdrawal amount is too small",
    "hbc.notification.created": "You have committed {dollars} to be invested",
    "hbc.notification.modified": "You have modified your investment commitment",
    "hbc.notification.canceled": "You have canceled your investment commitment",
    "hbc.notification.invest.processed": "Your investment was processed",
    "hbc.notification.account.denied": "Your Uphold account access was denied",
    "hbc.notification.account.not.support.bitcoin": "Your Uphold account does not currently support Bitcoin",
    "hbc.notification.not.enough.funds": "Your Uphold account does not currently have sufficient funds for your investment commitment",
    "hbc.notification.card.created": "A separate Uphold card was created for your Hedged Bitcoin investment",
    "hbc.notification.account.not.found": "Account was not found",
    "hbc.notification.account.incomplete": "Account is incomplete",
    "hbc.notification.account.not.confirmed": "Account is not confirmed",
    "hbc.notification.account.unauthorized": "Account is unauthorized",
    "hbc.notification.account.updated": "Account was updated",
    "hbc.notification.failed.update.account": "Account update error",
    "hbc.notification.failed.create.invest": "Investment error",
    "hbc.notification.failed.modify.invest": "Investment error",
    "hbc.notification.failed.cancel.invest": "Investment cancellation error",
    "hbc.notification.card.not.found": "Uphold card was not found",
    "hbc.notification.found.more.then.one.card.with.the.same.currency": "Found more then one card with the same currency",
    "hbc.notification.failed.create.card": "Failed to create Uphold card",
    "hbc.notification.failed.create.card.currency.not.available": "Selected currency is not available",
    "hbc.notification.failed.create.card.status.pending": "Failed to create Uphold card: pending",
    "hbc.notification.card.was.updated": "Uphold card was updated",
    "hbc.notification.failed.update.card": "Uphold card update error",
    "hbc.notification.transaction.not.found": "Transaction was not found",
    "hbc.notification.transaction.successful.completed": "Transaction completed successfully",
    "hbc.notification.failed.transaction": "Transaction failed",
    "hbc.notification.app.error": "Application error",
    "hbc.notification.withdrawal.initiated": "You have submitted a withdrawal",
    "hbc.notification.withdrawal.error": "Insufficient funds for withdrawal",
    "hbc.notification.withdrawal.modified": "You have modified the withdrawal",
    "hbc.notification.withdrawal.canceled": "You have canceled your withdrawal",
    "hbc.notification.title": "Notifications",
    "hbc.notification.no.notifications": "No notifications",
    "hbc.notification.no.notifications.invest.now": "Invest Now",
    "hbc.notification.making": "Application error. If the error persists, please contact support@uphold.com",
    "hbc.disclosures.title": "Disclosures",
    "hbc.disclosures.text.service": "Hedged Bitcoin service is provided by ",
    "hbc.disclosures.text.service.ternary.intelligence": "Ternary Intelligence",
    "hbc.disclosures.text.powered": " and is powered by the ",
    "hbc.disclosures.text.powered.uphold.platform": "Uphold Platform",
    "hbc.disclosures.text.agree": "By using the service, you agree to the ",
    "hbc.disclosures.text.terms": "Terms of Service",
    "hbc.disclosures.text.and": " and ",
    "hbc.disclosures.text.privacy": "Privacy Policy",
    "hbc.disclosures.text0": "Hedged Bitcoin service is provided by Ternary Intelligence and is powered by the Uphold Platform.",
    "hbc.disclosures.text1": "By using the service, you agree to the Terms of Service and Privacy Policy.",
    "hbc.header.menu0": "Dashboard",
    "hbc.header.menu1": "Invest",
    "hbc.header.menu2": "Withdraw",
    "hbc.header.menu3": "Notifications",
    "hbc.header.menu4": "Account",
    "hbc.header.menu5": "Settings",
    "hbc.header.menu6": "Help",
    "hbc.header.menu7": "Disclosures",
    "hbc.header.menu8": "Logout",
    "hbc.header.submenu0": "Settings",
    "hbc.header.submenu1": "Help",
    "hbc.header.submenu2": "Disclosures",
    "hbc.header.submenu3": "Log Out",
    "hbc.login.title": "Hedged Bitcoin",
    "hbc.login.button1": "Connect with",
    "hbc.login.button2": "Uphold",
    "hbc.login.powered": "Powered by the Uphold Platform",
    "hbc.login.terms0": "By authorizing the Hedged Bitcoin service",
    "hbc.login.terms1": "you have read and agree to our",
    "hbc.login.terms2": "terms of service",
    "hbc.login.terms3": "and",
    "hbc.login.terms4": "privacy policy",
    "hbc.login.header.signup": "Sign Up",
    "hbc.login.header.login": "Log In",
    "hbc.login.white.paper": "White Paper",
    "hbc.login.privacy.policy": "Terms of Service and Privacy Policy",
    "hbc.login.added.auth": "Authorization complete",
    "hbc.login.added.continue": "Continue",
    "hbc.login.added.continue.to": "to Hedged Bitcoin",
    "hbc.login.added.continue.button": "CONTINUE"
  },
  ES: {
    "hbc.settings.title": "Configuración",
    "hbc.settings": "Sí, por favor envíenme actualizaciones, consejos y ofertas relacionadas con este producto por correo electrónico",
    "hbc.dashboard.title": "Panel de control",
    "hbc.dashboard.left.title": "saldo comprometido",
    "hbc.dashboard.right.title": "fecha del primer compromiso",
    "hbc.dashboard.right.title.two": "fecha del primera inversión",
    "hbc.dashboard.ok.warning": "Lo sentimos, pero tu cuenta de Uphold no es compatible con Bitcoin. Ponte en contacto con ",
    "hbc.dashboard.ok.warning.uphold.support": "Uphold Soporte",
    "hbc.dashboard.pending.warning": "Por favor, configura tu ",
    "hbc.dashboard.pending.warning.uphold": "Cuenta de Uphold",
    "hbc.dashboard.restricted.warning": "Tu cuenta de Uphold está sujeta a limitaciones, verifica ",
    "hbc.dashboard.restricted.warning.your.account": "tu cuenta",
    "hbc.dashboard.blocked.warning": "Tu cuenta de Uphold está restringida, ponte en contacto con ",
    "hbc.dashboard.status.waitlist": "Estado: Lista De Espera",
    "hbc.dashboard.first.date.jan": "Ene",
    "hbc.dashboard.first.date.feb": "Feb",
    "hbc.dashboard.first.date.mar": "Mar",
    "hbc.dashboard.first.date.apr": "Abr",
    "hbc.dashboard.first.date.may": "Mayo",
    "hbc.dashboard.first.date.jun": "Jun",
    "hbc.dashboard.first.date.jul": "Jul",
    "hbc.dashboard.first.date.aug": "Ago",
    "hbc.dashboard.first.date.sep": "Sep",
    "hbc.dashboard.first.date.oct": "Oct",
    "hbc.dashboard.first.date.nov": "Nov",
    "hbc.dashboard.first.date.dec": "Dic",
    "hbc.dashboard.invest": "Invertir",
    "hbc.dashboard.insufficient.warning": "No tienes fondos suficientes para su depósito. Por favor revise su saldo en ",
    "hbc.dashboard.hedged.bitcoin.performance": "Rendimiento de Hedged Bitcoin",
    "hbc.dashboard.balance.estimate": "La estimación del saldo se actualizó en {currentDate}",
    "hbc.dashboard.balance.estimates.see": "LaFechas estimaciones de saldo pueden ser diferentes del valor real al momento del retiro; por favor vea los ",
    "hbc.dashboard.for.more.information": " para más información",
    "hbc.dashboard.date": "a partir del ",
    "hbc.dashboard.account.history": "historia de cuenta",
    "hbc.dashboard.account.history.date": "Fecha",
    "hbc.dashboard.account.history.balance": "Saldo",
    "hbc.dashboard.account.history.gain.loss": "Incrementar/Pérdida",
    "hbc.dashboard.account.history.fee": "Comisión",
    "hbc.dashboard.center.title": "SALDO ACTUAL",
    "hbc.dashboard.status.invested": "Estado: Invertido",
    "hbc.invest.title": "Fiduciario",
    "hbc.invest.crypto.title": "Cripto",
    "hbc.invest.added": "Añadido a la lista de espera:",
    "hbc.invest.modify": "modificar",
    "hbc.invest.cancel": "cancelar",
    "hbc.invest.select": "Selecciona activo para depositar:",
    "hbc.invest.added.to.waitlist": "Tu depósito será añadido a la lista de espera.",
    "hbc.invest.added.to.waitlist.two": "Los depósitos y retiros están sujetos a costos de conversión de activos. Consulta ",
    "hbc.invest.added.to.waitlist.two.tos": "Términos de Servicio",
    "hbc.invest.added.to.waitlist.two.and": " y ",
    "hbc.invest.added.to.waitlist.two.faq": "Preguntas frecuentes",
    "hbc.invest.input": "Ingresa el monto:",
    "hbc.invest.submit": "enviar",
    "hbc.invest.confirm": "Confirmar depósito",
    "hbc.invest.confirm.message": "¿Añadir {AmountAndCurrency} a la lista de espera?",
    "hbc.invest.confirm.ok": "OK",
    "hbc.invest.confirm.no": "NO",
    "hbc.invest.cancel.deposit": "Cancelar depósito",
    "hbc.invest.cancel.deposit.message": "¿Estás seguro que deseas cancelar el compromiso de depósito y perder tu lugar en la lista de espera?",
    "hbc.invest.cancel.deposit.ok": "OK",
    "hbc.invest.cancel.deposit.no": "NO",
    "hbc.withdraw.amount.committed": " comprometido",
    "hbc.withdraw.title": "Retirar",
    "hbc.withdraw.select": "Selecciona el activo a retirar:",
    "hbc.withdraw.percentage": "Ingresa el porcentaje a retirar:",
    "hbc.withdraw.your.balance": "Tu saldo es de {AmountAndCurrency} a partir del {someDefDate}",
    "hbc.withdraw.processed": "Tu retiro será procesado el {someDefDate}",
    "hbc.withdraw.added.to.waitlist.two": "Los retiros están sujetos a costos de conversión de activos. Consulta ",
    "hbc.withdraw.added.to.waitlist.two.tos": "Términos de Servicio",
    "hbc.withdraw.added.to.waitlist.two.and": " y ",
    "hbc.withdraw.added.to.waitlist.two.faq": "Preguntas frecuentes",
    "hbc.withdraw.added": "Añadido a la lista de espera",
    "hbc.withdraw.modify": "modificar",
    "hbc.withdraw.cancel": "cancelar",
    "hbc.withdraw.cancel.deposit": "Retirar",
    "hbc.withdraw.cancel.deposit.message": "¿Cancelar retiro?’",
    "hbc.withdraw.cancel.deposit.button": "cancel deposit (ES)",
    "hbc.withdraw.cancel.deposit.ok": "OK",
    "hbc.withdraw.cancel.deposit.no": "NO",
    "hbc.withdraw.withdraw.deposit": "Retirar",
    "hbc.withdraw.withdraw.deposit.message": "¿Estás seguro que deseas retirar tu activo?",
    "hbc.withdraw.withdraw.deposit.ok": "OK",
    "hbc.withdraw.withdraw.deposit.no": "NO",
    "hbc.withdraw.withdraw.deposit.error.small": "La cantidad de retiro es demasiado pequeña",
    "hbc.notification.created": "Has comprometido {dollars} para ser invertidos",
    "hbc.notification.modified": "Has modificado tu compromiso de inversión",
    "hbc.notification.canceled": "Has cancelado tu compromiso de inversión",
    "hbc.notification.invest.processed": "Su inversión fue procesada",
    "hbc.notification.account.denied": "Se negó el acceso a tu cuenta de Uphold",
    "hbc.notification.account.not.support.bitcoin": "Tu cuenta de Uphold no es compatible actualmente con Bitcoin",
    "hbc.notification.not.enough.funds": "Tu cuenta de Uphold actualmente no cuenta con fondos suficientes para tu compromiso de inversión",
    "hbc.notification.card.created": "Se creó una tarjeta de Uphold separada para tu inversión en Hedged Bitcoin",
    "hbc.notification.account.not.found": "No se encontró la cuenta",
    "hbc.notification.account.incomplete": "La cuenta esta incompleta",
    "hbc.notification.account.not.confirmed": "Cuenta no confirmada",
    "hbc.notification.account.unauthorized": "La cuenta no está autorizada",
    "hbc.notification.account.updated": "La cuenta fue actualizada",
    "hbc.notification.failed.update.account": "Error de actualización de cuenta",
    "hbc.notification.failed.create.invest": "Error de inversión",
    "hbc.notification.failed.modify.invest": "Error de inversión",
    "hbc.notification.failed.cancel.invest": "Error de cancelación de inversión",
    "hbc.notification.card.not.found": "No se encontró la Uphold tarjeta",
    "hbc.notification.found.more.then.one.card.with.the.same.currency": "Encontró más de una tarjeta con la misma moneda.",
    "hbc.notification.failed.create.card": "Error al crear la Uphold tarjeta",
    "hbc.notification.failed.create.card.currency.not.available": "La moneda seleccionada no está disponible",
    "hbc.notification.failed.create.card.status.pending": "Error al crear la tarjeta Uphold: pendiente",
    "hbc.notification.card.was.updated": "La Uphold tarjeta fue actualizada",
    "hbc.notification.failed.update.card": "Error de actualización de la Uphold tarjeta",
    "hbc.notification.transaction.not.found": "No se encontró la transacción",
    "hbc.notification.transaction.successful.completed": "Transacción completada exitosamente",
    "hbc.notification.failed.transaction": "Transacción fallida",
    "hbc.notification.app.error": "Error de la aplicación",
    "hbc.notification.withdrawal.initiated": "Has iniciado un retirada",
    "hbc.notification.withdrawal.error": "Fondos insuficientes para completar el retirada",
    "hbc.notification.withdrawal.modified": "Has modificado tu retirada",
    "hbc.notification.withdrawal.canceled": "Has cancelado tu retirar",
    "hbc.notification.title": "Notificaciones",
    "hbc.notification.no.notifications": "No hay notificaciones",
    "hbc.notification.no.notifications.invest.now": "Invertir ahora",
    "hbc.notification.making": "Error de aplicación. Si continúa el error, ponte en contacto con support@uphold.com",
    "hbc.disclosures.title": "Divulgaciones",
    "hbc.disclosures.text.service": "El servicio de Hedged Bitcoin es proporcionado por ",
    "hbc.disclosures.text.service.ternary.intelligence": "Ternary Intelligence",
    "hbc.disclosures.text.powered": " y desarrollado sobre la ",
    "hbc.disclosures.text.powered.uphold.platform": "Plataforma Uphold",
    "hbc.disclosures.text.agree": "Al utilizar el servicio, aceptas los ",
    "hbc.disclosures.text.terms": "Términos de Servicio",
    "hbc.disclosures.text.and": " y ",
    "hbc.disclosures.text.privacy": "Política de Privacidad",
    "hbc.disclosures.text0": "El servicio de Hedged Bitcoin es proporcionado por Ternary Intelligence y desarrollado sobre la Plataforma Uphold.",
    "hbc.disclosures.text1": "Al utilizar el servicio, aceptas los Términos de Servicio y Política de Privacidad.",
    "hbc.header.menu0": "Panel de control",
    "hbc.header.menu1": "Invertir",
    "hbc.header.menu2": "Retirar",
    "hbc.header.menu3": "Notificaciones",
    "hbc.header.menu4": "Cuenta",
    "hbc.header.menu5": "Configuración",
    "hbc.header.menu6": "Ayuda",
    "hbc.header.menu7": "Divulgaciones",
    "hbc.header.menu8": "Cerrar sesión",
    "hbc.header.submenu0": "Configuración",
    "hbc.header.submenu1": "Ayuda",
    "hbc.header.submenu2": "Divulgaciones",
    "hbc.header.submenu3": "Cerrar Sesión",
    "hbc.login.title": "Hedged Bitcoin",
    "hbc.login.button1": "Conectar con",
    "hbc.login.button2": "Uphold",
    "hbc.login.powered": "Desarrollado sobre la Plataforma Uphold",
    "hbc.login.terms0": "Al autorizar el servicio Hedged Bitcoin",
    "hbc.login.terms1": "declaras haber leído y aceptado nuestros",
    "hbc.login.terms2": "términos de servicio",
    "hbc.login.terms3": "y",
    "hbc.login.terms4": "política de privacidad",
    "hbc.login.header.signup": "Inscríbete",
    "hbc.login.header.login": "Inicia sesión",
    "hbc.login.white.paper": "Libro Blanco (EN)",
    "hbc.login.privacy.policy": "Términos de Servicio y Política de Privacidad (EN)",
    "hbc.login.added.auth": "La autorización esta completa",
    "hbc.login.added.continue": "Continuar",
    "hbc.login.added.continue.to": "hasta Hedged Bitcoin",
    "hbc.login.added.continue.button": "CONTINUAR"
  },
  PT: {
    "hbc.settings.title": "Configurações",
    "hbc.settings": "Sim, envie-me atualizações, dicas e ofertas por e-mail relacionadas com este produto",
    "hbc.dashboard.title": "Dashboard",
    "hbc.dashboard.left.title": "saldo a investir",
    "hbc.dashboard.right.title": "data do primeiro investimento",
    "hbc.dashboard.right.title.two": "data do primeiro investimento",
    "hbc.dashboard.ok.warning": "Desculpe, mas sua conta Uphold não é compatível com Bitcoin. Entre em contato com ",
    "hbc.dashboard.ok.warning.uphold.support": "Uphold Suporte",
    "hbc.dashboard.pending.warning": "Termine a configuração da sua ",
    "hbc.dashboard.pending.warning.uphold": "Conta Uphold",
    "hbc.dashboard.restricted.warning": "Sua conta Uphold está sujeita a limitações, verifique ",
    "hbc.dashboard.restricted.warning.your.account": "sua conta",
    "hbc.dashboard.blocked.warning": "Sua conta Uphold é restrita, entre em contato com ",
    "hbc.dashboard.status.waitlist": "Estado: Lista de espera",
    "hbc.dashboard.first.date.jan": "Jan",
    "hbc.dashboard.first.date.feb": "Fev",
    "hbc.dashboard.first.date.mar": "Mar",
    "hbc.dashboard.first.date.apr": "Abr",
    "hbc.dashboard.first.date.may": "Mai",
    "hbc.dashboard.first.date.jun": "Jun",
    "hbc.dashboard.first.date.jul": "Jul",
    "hbc.dashboard.first.date.aug": "Ago",
    "hbc.dashboard.first.date.sep": "Set",
    "hbc.dashboard.first.date.oct": "Out",
    "hbc.dashboard.first.date.nov": "Nov",
    "hbc.dashboard.first.date.dec": "Dez",
    "hbc.dashboard.invest": "investir",
    "hbc.dashboard.insufficient.warning": "Você não tem fundos suficientes para o seu investimento. Por favor, verifique seu saldo em ",
    "hbc.dashboard.hedged.bitcoin.performance": "Desempenho de Hedged Bitcoin",
    "hbc.dashboard.balance.estimate": "A estimativa do saldo foi atualizada em {currentDate}",
    "hbc.dashboard.balance.estimates.see": "As estimativas de saldo podem ser diferentes do valor real após a retirada; por favor veja os ",
    "hbc.dashboard.for.more.information": " para mais informações",
    "hbc.dashboard.date": "a partir de ",
    "hbc.dashboard.account.history": "histórico da conta",
    "hbc.dashboard.account.history.date": "Data",
    "hbc.dashboard.account.history.balance": "Saldo",
    "hbc.dashboard.account.history.gain.loss": "Ganho/Perda",
    "hbc.dashboard.account.history.fee": "Despesa",
    "hbc.dashboard.center.title": "BALANÇO ATUAL",
    "hbc.dashboard.status.invested": "Estado: Investido",
    "hbc.invest.title": "Fiduciária",
    "hbc.invest.crypto.title": "Cripto",
    "hbc.invest.added": "Adicionada à lista de espera:",
    "hbc.invest.modify": "modificar",
    "hbc.invest.cancel": "cancelar",
    "hbc.invest.select": "Selecione ativo para depositar:",
    "hbc.invest.added.to.waitlist": "Seu depósito será adicionado à lista de espera.",
    "hbc.invest.added.to.waitlist.two": "Depósitos e levantamentos estão sujeitos a custos de conversão de ativo. Veja ",
    "hbc.invest.added.to.waitlist.two.tos": "Termos de serviço",
    "hbc.invest.added.to.waitlist.two.and": " e ",
    "hbc.invest.added.to.waitlist.two.faq": "Perguntas frequentes",
    "hbc.invest.input": "Digite o valor:",
    "hbc.invest.submit": "enviar",
    "hbc.invest.confirm": "Confirmar depósito",
    "hbc.invest.confirm.message": "Adicionar {AmountAndCurrency} à lista de espera?",
    "hbc.invest.confirm.ok": "OK",
    "hbc.invest.confirm.no": "NÃO",
    "hbc.invest.cancel.deposit": "Cancelar depósito",
    "hbc.invest.cancel.deposit.message": "Deseja mesmo cancelar o compromisso de depósito e perder seu lugar na lista de espera?",
    "hbc.invest.cancel.deposit.ok": "OK",
    "hbc.invest.cancel.deposit.no": "NÃO",
    "hbc.withdraw.amount.committed": " a investir",
    "hbc.withdraw.title": "Levantar",
    "hbc.withdraw.select": "Selecione ativo para sacar:",
    "hbc.withdraw.percentage": "Digite o percentual do levantamento:",
    "hbc.withdraw.your.balance": "Seu saldo é {AmountAndCurrency} a partir de {someDefDate}",
    "hbc.withdraw.processed": "Seu levantamento será processado em {someDefDate}",
    "hbc.withdraw.added.to.waitlist.two": "Levantamentos estão sujeitos a custos de conversão de ativo. Veja ",
    "hbc.withdraw.added.to.waitlist.two.tos": "Termos de serviço",
    "hbc.withdraw.added.to.waitlist.two.and": " e ",
    "hbc.withdraw.added.to.waitlist.two.faq": "Perguntas frequentes",
    "hbc.withdraw.added": "Adicionado à lista de espera",
    "hbc.withdraw.modify": "modificar",
    "hbc.withdraw.cancel": "Cancelar depósito",
    "hbc.withdraw.cancel.deposit": "Levantar",
    "hbc.withdraw.cancel.deposit.message": "Cancelar retirada?",
    "hbc.withdraw.cancel.deposit.ok": "OK",
    "hbc.withdraw.cancel.deposit.no": "NÃO",
    "hbc.withdraw.withdraw.deposit": "Levantar",
    "hbc.withdraw.withdraw.deposit.message": "Deseja mesmo quer retirar seu ativo?",
    "hbc.withdraw.withdraw.deposit.ok": "OK",
    "hbc.withdraw.withdraw.deposit.no": "NÃO",
    "hbc.withdraw.withdraw.deposit.error.small": "Quantidade de retirada é muito pequena",
    "hbc.notification.created": "Você comprometeu {dollars} para investimento",
    "hbc.notification.modified": "Você modificou seu compromisso de investimento",
    "hbc.notification.canceled": "Você cancelou seu compromisso de investimento",
    "hbc.notification.invest.processed": "Seu investimento foi processado",
    "hbc.notification.account.denied": "Seu acesso à conta Uphold foi negado",
    "hbc.notification.account.not.support.bitcoin": "Sua conta Uphold atualmente não é compatível com Bitcoin",
    "hbc.notification.not.enough.funds": "Sua conta Uphold não tem fundos suficientes atualmente para seu compromisso de investimento",
    "hbc.notification.card.created": "Foi criado um cartão Uphold separado para seu investimento Hedged Bitcoin",
    "hbc.notification.account.not.found": "A conta não foi encontrada",
    "hbc.notification.account.incomplete": "A conta está incompleta",
    "hbc.notification.account.not.confirmed": "Conta não confirmada",
    "hbc.notification.account.unauthorized": "Conta não autorizada",
    "hbc.notification.account.updated": "Conta foi atualizada",
    "hbc.notification.failed.update.account": "Erro de atualização da conta",
    "hbc.notification.failed.create.invest": "Erro de investimento",
    "hbc.notification.failed.modify.invest": "Erro de investimento",
    "hbc.notification.failed.cancel.invest": "Erro de cancelamento de investimento",
    "hbc.notification.card.not.found": "Uphold cartão não foi encontrada",
    "hbc.notification.found.more.then.one.card.with.the.same.currency": "Encontramos mais de um cartão com a mesma moeda",
    "hbc.notification.failed.create.card": "Não foi possível criar o Uphold cartão",
    "hbc.notification.failed.create.card.currency.not.available": "A moeda selecionada não está disponível",
    "hbc.notification.failed.create.card.status.pending": "Não foi possível criar o Uphold cartão: pendente",
    "hbc.notification.card.was.updated": "Uphold cartão foi atualizada",
    "hbc.notification.failed.update.card": "Uphold cartão erro",
    "hbc.notification.transaction.not.found": "A transação não foi encontrada",
    "hbc.notification.transaction.successful.completed": "Transação concluída com sucesso",
    "hbc.notification.failed.transaction": "Falha na transação",
    "hbc.notification.app.error": "Erro de aplicação",
    "hbc.notification.withdrawal.initiated": "Você iniciou uma retirada",
    "hbc.notification.withdrawal.error": "Fundos insuficientes para retirada",
    "hbc.notification.withdrawal.modified": "Você modificou seu retirada",
    "hbc.notification.withdrawal.canceled": "Você cancelou seu retirada",
    "hbc.notification.title": "Notificações",
    "hbc.notification.no.notifications": "Não há notificações",
    "hbc.notification.no.notifications.invest.now": "Investir agora",
    "hbc.notification.making": "Erro de aplicativo. Se o erro continuar, entre em contato com support@uphold.com",
    "hbc.disclosures.title": "Divulgações",
    "hbc.disclosures.text.service": "O serviço de Hedged Bitcoin é fornecido pela ",
    "hbc.disclosures.text.service.ternary.intelligence": "Ternary Intelligence",
    "hbc.disclosures.text.powered": " e foi desenvolvido na ",
    "hbc.disclosures.text.powered.uphold.platform": "plataforma Uphold",
    "hbc.disclosures.text.agree": "Ao usar o serviço, você concorda com os ",
    "hbc.disclosures.text.terms": "Termos de serviço",
    "hbc.disclosures.text.and": " e ",
    "hbc.disclosures.text.privacy": "Política de privacidade",
    "hbc.disclosures.text0": "O serviço de Hedged Bitcoin é fornecido pela Ternary Intelligence e foi desenvolvido na plataforma Uphold.",
    "hbc.disclosures.text1": "Ao usar o serviço, você concorda com os Termos de serviço e Política de privacidade.",
    "hbc.header.menu0": "Dashboard",
    "hbc.header.menu1": "Investir",
    "hbc.header.menu2": "Levantar",
    "hbc.header.menu3": "Notificações",
    "hbc.header.menu4": "Conta",
    "hbc.header.menu5": "Configurações",
    "hbc.header.menu6": "Ajuda",
    "hbc.header.menu7": "Divulgações",
    "hbc.header.menu8": "Sair",
    "hbc.header.submenu0": "Configurações",
    "hbc.header.submenu1": "Ajuda",
    "hbc.header.submenu2": "Divulgações",
    "hbc.header.submenu3": "Sair",
    "hbc.login.title": "Hedged Bitcoin",
    "hbc.login.button1": "Conectar com",
    "hbc.login.button2": "Uphold",
    "hbc.login.powered": "Desenvolvido na plataforma Uphold",
    "hbc.login.terms0": "Ao autorizar o serviço de Hedged Bitcoin",
    "hbc.login.terms1": "você declara que leu e concorda com nossos",
    "hbc.login.terms2": "termos de serviço",
    "hbc.login.terms3": "e",
    "hbc.login.terms4": "política de privacidade",
    "hbc.login.header.signup": "Cadastro",
    "hbc.login.header.login": "Entrar",
    "hbc.login.white.paper": "White Paper (EN)",
    "hbc.login.privacy.policy": "Termos de serviço e Política de privacidade (EN)",
    "hbc.login.added.auth": "A autorização está completa",
    "hbc.login.added.continue": "Continue",
    "hbc.login.added.continue.to": "para Hedged Bitcoin",
    "hbc.login.added.continue.button": "CONTINUAR"
  },
  ZH: {
    "hbc.settings.title": "设置",
    "hbc.settings": "是的，请通过电子邮件向我发送与此产品相关的更新、技巧和优惠",
    "hbc.dashboard.title": "控制面板",
    "hbc.dashboard.left.title": "保证存入的金额",
    "hbc.dashboard.right.title": "首次保证日期",
    "hbc.dashboard.right.title.two": "第一次投资的日期",
    "hbc.dashboard.ok.warning.uphold.support": "Uphold 支持",
    "hbc.dashboard.ok.warning": "抱歉，但您的 Uphold 帐户不支持比特币。请联系 ",
    "hbc.dashboard.pending.warning": "请完成此项设置： ",
    "hbc.dashboard.pending.warning.uphold": "Uphold 帐户",
    "hbc.dashboard.restricted.warning": "您的 Uphold 帐户受限，请联系 ",
    "hbc.dashboard.restricted.warning.your.account": "你的帳戶",
    "hbc.dashboard.blocked.warning": "您的 Uphold 账户受约束，请联系 ",
    "hbc.dashboard.status.waitlist": "状况：等候名单",
    "hbc.dashboard.first.date.jan": "一月",
    "hbc.dashboard.first.date.feb": "二月",
    "hbc.dashboard.first.date.mar": "三月",
    "hbc.dashboard.first.date.apr": "四月",
    "hbc.dashboard.first.date.may": "五月",
    "hbc.dashboard.first.date.jun": "六月",
    "hbc.dashboard.first.date.jul": "七月",
    "hbc.dashboard.first.date.aug": "八月",
    "hbc.dashboard.first.date.sep": "九月",
    "hbc.dashboard.first.date.oct": "十月",
    "hbc.dashboard.first.date.nov": "十一月",
    "hbc.dashboard.first.date.dec": "十二月",
    "hbc.dashboard.invest": "投资",
    "hbc.dashboard.insufficient.warning": "您的承诺存款资金不足。 请检查您的余额 ",
    "hbc.dashboard.hedged.bitcoin.performance": "Hedged Bitcoin 业绩",
    "hbc.dashboard.balance.estimate": "余额估计最后更新于 {currentDate}",
    "hbc.dashboard.balance.estimates.see": "余额估计可能与退出时的实际价值不同; 请看 ",
    "hbc.dashboard.for.more.information": " 欲获得更多信息",
    "hbc.dashboard.date": "截止 ",
    "hbc.dashboard.account.history": "帐户历史记录",
    "hbc.dashboard.account.history.date": "日期",
    "hbc.dashboard.account.history.balance": "平衡",
    "hbc.dashboard.account.history.gain.loss": "增益/损失",
    "hbc.dashboard.account.history.fee": "出费",
    "hbc.dashboard.center.title": "当前的平衡",
    "hbc.dashboard.status.invested": "状况：投资",
    "hbc.invest.title": "法定货币",
    "hbc.invest.crypto.title": "加密货币",
    "hbc.invest.added": "已添加至等候名单：",
    "hbc.invest.modify": "修改",
    "hbc.invest.cancel": "取消",
    "hbc.invest.select": "选择要存入的资产：",
    "hbc.invest.added.to.waitlist": "将添加存入款项至等候名单。",
    "hbc.invest.added.to.waitlist.two": "存入或赎回均将收取资产转换成本。请查看 ",
    "hbc.invest.added.to.waitlist.two.tos": "服务条款",
    "hbc.invest.added.to.waitlist.two.and": " 和 ",
    "hbc.invest.added.to.waitlist.two.faq": "常见问题",
    "hbc.invest.input": "输入金额：",
    "hbc.invest.submit": "提交",
    "hbc.invest.confirm": "确认存入",
    "hbc.invest.confirm.message": "是否要在等候名单中添加 {AmountAndCurrency}？",
    "hbc.invest.confirm.ok": "好",
    "hbc.invest.confirm.no": "没有",
    "hbc.invest.cancel.deposit": "取消存入",
    "hbc.invest.cancel.deposit.message": "是否确实要取消存入保证存入的金额，并放弃在等候名单上排位？",
    "hbc.invest.cancel.deposit.ok": "好",
    "hbc.invest.cancel.deposit.no": "没有",
    "hbc.withdraw.amount.committed": " 已提交",
    "hbc.withdraw.title": "赎回",
    "hbc.withdraw.select": "选择要赎回的资产：",
    "hbc.withdraw.percentage": "输入要赎回的百分比：",
    "hbc.withdraw.your.balance": "截止 {someDefDate}，您的余额为 {AmountAndCurrency}",
    "hbc.withdraw.processed": "您的赎回操作将于 {someDefDate}处理",
    "hbc.withdraw.added.to.waitlist.two": "将向此次赎回收取资产转换成本。请查看 ",
    "hbc.withdraw.added.to.waitlist.two.tos": "服务条款",
    "hbc.withdraw.added.to.waitlist.two.and": " 和 ",
    "hbc.withdraw.added.to.waitlist.two.faq": "常见问题",
    "hbc.withdraw.added": "已添加至等候名单",
    "hbc.withdraw.modify": "修改",
    "hbc.withdraw.cancel": "取消存入",
    "hbc.withdraw.cancel.deposit": "赎回",
    "hbc.withdraw.cancel.deposit.message": "取消取款？",
    "hbc.withdraw.cancel.deposit.ok": "好",
    "hbc.withdraw.cancel.deposit.no": "没有",
    "hbc.withdraw.withdraw.deposit": "赎回",
    "hbc.withdraw.withdraw.deposit.message": "是否确实要提取你的资产吗？",
    "hbc.withdraw.withdraw.deposit.ok": "好",
    "hbc.withdraw.withdraw.deposit.no": "没有",
    "hbc.withdraw.withdraw.deposit.error.small": "提款 金额 太小",
    "hbc.notification.created": "您已承诺将 {dollars} 用于投资",
    "hbc.notification.modified": "您已修改投资投入",
    "hbc.notification.canceled": "您已取消投资投入",
    "hbc.notification.invest.processed": "您的投资已得到处理",
    "hbc.notification.account.denied": "您的 Uphold 帐户访问遭拒",
    "hbc.notification.account.not.support.bitcoin": "您的 Uphold 帐户目前不支持比特币",
    "hbc.notification.not.enough.funds": "您的 Uphold 帐户目前资金不足，无法进行投资投入",
    "hbc.notification.card.created": "已创建单独的 Uphold 卡，可用于 Hedged Bitcoin 投资",
    "hbc.notification.account.not.found": "帐户未找到",
    "hbc.notification.account.incomplete": "帐户不完整",
    "hbc.notification.account.not.confirmed": "帐户未确认",
    "hbc.notification.account.unauthorized": "帐户未经授权",
    "hbc.notification.account.updated": "帐户已更新",
    "hbc.notification.failed.update.account": "帐户更新错误",
    "hbc.notification.failed.create.invest": "投资错误",
    "hbc.notification.failed.modify.invest": "投资错误",
    "hbc.notification.failed.cancel.invest": "投资取消错误",
    "hbc.notification.card.not.found": "Uphold卡未找到",
    "hbc.notification.found.more.then.one.card.with.the.same.currency": "我们找到了多张同一种货币的卡片",
    "hbc.notification.failed.create.card": "无法创建Uphold卡",
    "hbc.notification.failed.create.card.currency.not.available": "所选货币不可用",
    "hbc.notification.failed.create.card.status.pending": "无法创建Uphold卡：待处理",
    "hbc.notification.card.was.updated": "Uphold卡已更新",
    "hbc.notification.failed.update.card": "Uphold卡更新错误",
    "hbc.notification.transaction.not.found": "未找到此交易",
    "hbc.notification.transaction.successful.completed": "交易成功完成",
    "hbc.notification.failed.transaction": "交易失败",
    "hbc.notification.app.error": "应用程序错误",
    "hbc.notification.withdrawal.initiated": "您已提交提款",
    "hbc.notification.withdrawal.error": "资金不足以完成提款",
    "hbc.notification.withdrawal.modified": "您已修改提款",
    "hbc.notification.withdrawal.canceled": "您已取消提款",
    "hbc.notification.title": "通知",
    "hbc.notification.no.notifications": "您没有任何通知",
    "hbc.notification.no.notifications.invest.now": "立即投资",
    "hbc.notification.making": "应用错误。若错误仍然存在，请联系 support@uphold.com",
    "hbc.disclosures.title": "披露",
    "hbc.disclosures.text.service": "Hedged Bitcoin 服务由 ",
    "hbc.disclosures.text.service.ternary.intelligence": "Ternary Intelligence",
    "hbc.disclosures.text.powered": " 提供，并由 ",
    "hbc.disclosures.text.powered.uphold.platform": "Uphold Platform 提供技术支持。",
    "hbc.disclosures.text.agree": "使用此服务即表示，您同意",
    "hbc.disclosures.text.terms": "服务条款",
    "hbc.disclosures.text.and": " 和 ",
    "hbc.disclosures.text.privacy": "隐私政策",
    "hbc.disclosures.text0": "Hedged Bitcoin 服务由 Ternary Intelligence 提供，并由 Uphold Platform 提供技术支持。",
    "hbc.disclosures.text1": "使用此服务即表示，您同意服务条款和隐私政策。",
    "hbc.header.menu0": "控制面板",
    "hbc.header.menu1": "投资",
    "hbc.header.menu2": "赎回",
    "hbc.header.menu3": "通知",
    "hbc.header.menu4": "帐户",
    "hbc.header.menu5": "设置",
    "hbc.header.menu6": "帮助",
    "hbc.header.menu7": "披露",
    "hbc.header.menu8": "注销",
    "hbc.header.submenu0": "设置",
    "hbc.header.submenu1": "帮助",
    "hbc.header.submenu2": "披露",
    "hbc.header.submenu3": "注销",
    "hbc.login.title": "Hedged Bitcoin",
    "hbc.login.button1": "连接至",
    "hbc.login.button2": "Uphold",
    "hbc.login.powered": "Hedged Bitcoin 由 Uphold Platform 提供技术支持",
    "hbc.login.terms0": "授权 Hedged Bitcoin 服务，",
    "hbc.login.terms1": "表示您已阅读并同意",
    "hbc.login.terms2": "服务条款",
    "hbc.login.terms3": "和",
    "hbc.login.terms4": "隐私政策",
    "hbc.login.header.signup": "注册",
    "hbc.login.header.login": "登录",
    "hbc.login.white.paper": "白皮书 (EN)",
    "hbc.login.privacy.policy": "服务条款和隐私政策 (EN)",
    "hbc.login.added.auth": "授权完成",
    "hbc.login.added.continue": "继续",
    "hbc.login.added.continue.to": "Hedged Bitcoin",
    "hbc.login.added.continue.button": "继续"
  }
};
/* eslint-enable max-len */



// WEBPACK FOOTER //
// ./src/config/messages.js